var Size;
(function (Size) {
    Size["THREEXSMALL"] = "threexsmall";
    Size["TWOXSMALL"] = "twoxsmall";
    Size["XSMALL"] = "xsmall";
    Size["SMALL"] = "small";
    Size["MEDIUM"] = "medium";
    Size["LARGE"] = "large";
    Size["XLARGE"] = "xlarge";
    Size["TWOXLARGE"] = "twoxlarge";
    Size["THREEXLARGE"] = "threexlarge";
})(Size || (Size = {}));
export default Size;
